import { useEffect, useState } from 'react';
import { Loading, MessagePlugin, Table } from 'tdesign-react';

import { CgiErrorCode } from '@/services/cgi';
import { getInvitedList } from '@/services/finance';

interface Record {
  inviterUid: string; // 邀请人
  invitedUid: string; // 被邀请人
  createdAt: string;
}

const InvitedRecord = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Record[]>([]);
  const [pagination, setPagination] = useState({
    page: 1,
    size: 20,
    total: 0,
  });

  useEffect(() => {
    getList();
  }, [pagination.page, pagination.size]);

  const getList = async () => {
    setLoading(true);
    const { code, data, message } = await getInvitedList(pagination.page, pagination.size);
    if (code !== CgiErrorCode.NO_ERROR) {
      MessagePlugin.error(message || '邀请关系获取失败, 请稍后重试');
      setLoading(false);
      return;
    }
    setData(data?.list || []);
    setPagination(data?.pageinfo);
    setLoading(false);
  };

  const columns = [
    {
      title: '邀请人',
      colKey: 'inviterUid',
    },
    {
      title: '被邀请人ID',
      colKey: 'invitedUid',
    },
    {
      title: '邀请时间',
      colKey: 'createdAt',
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Loading loading={loading}>
        <Table
          rowKey="id"
          data={data}
          columns={columns}
          size='small'
          bordered={true}
          stripe={true}
          pagination={{
            current: pagination.page,
            pageSize: pagination.size,
            total: pagination.total,
            pageSizeOptions: [10, 20, 50, 100],
          }}
          onPageChange={v => setPagination(pre => ({
            ...pre,
            page: v.current,
            size: v.pageSize,
          }))}
        />
      </Loading>
    </div>
  );
};

export default InvitedRecord;
